export default __webpack_public_path__ + "static/media/logo_c.0cbb327f.png";